module.exports = __webpack_public_path__ + "static/img/图层13.4e215cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cardSolution/图层13.png
// module id = bOmy
// module chunks = 0